import { AfterViewInit, Component, DOCUMENT, ElementRef, Inject, Injector, OnInit, ViewChild } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { ThemesLayoutBaseComponent } from '@app/shared/layout/themes/themes-layout-base.component';
import { UrlHelper } from '@shared/helpers/UrlHelper';

import { NgClass } from '@angular/common';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';
import { OffcanvasOptions } from '@metronic/app/core/_base/layout/directives/offcanvas.directive';
import { LayoutRefService } from '@metronic/app/core/_base/layout/services/layout-ref.service';
import { AppConsts } from '@shared/AppConsts';
import { HeaderDirective } from '../../../../../assets/metronic/app/core/_base/layout/directives/header.directive';
import { OffcanvasDirective } from '../../../../../assets/metronic/app/core/_base/layout/directives/offcanvas.directive';
import { ToggleDirective } from '../../../../../assets/metronic/app/core/_base/layout/directives/toggle.directive';
import { FooterComponent } from '../../footer.component';
import { SideBarMenuComponent } from '../../nav/side-bar-menu.component';
import { ScrollTopComponent } from '../../scroll-top.component';
import { TopBarComponent } from '../../topbar.component';
import { Theme3BrandComponent } from './theme3-brand.component';

@Component({
    templateUrl: './theme3-layout.component.html',
    selector: 'theme3-layout',
    imports: [RouterLink, ToggleDirective, OffcanvasDirective, Theme3BrandComponent, SideBarMenuComponent, HeaderDirective, TopBarComponent, NgClass, RouterOutlet, FooterComponent, ScrollTopComponent]
})
export class Theme3LayoutComponent extends ThemesLayoutBaseComponent implements OnInit, AfterViewInit {

    @ViewChild('ktHeader', {static: true}) ktHeader: ElementRef;

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    menuCanvasOptions: OffcanvasOptions = {
        baseClass: 'kt-aside',
        overlay: true,
        closeBy: 'kt_aside_close_btn',
        toggleBy: [{
            target: 'kt_aside_mobile_toggler',
            state: 'kt-header-mobile__toolbar-toggler--active'
        }]
    };

    constructor(
        injector: Injector,
        private router: Router,
        @Inject(DOCUMENT) private document: Document,
        _dateTimeService: DateTimeService,
        private layoutRefService: LayoutRefService,
    ) {
        super(injector, _dateTimeService);
    }

    ngOnInit() {
        this.installationMode = UrlHelper.isInstallUrl(location.href);
    }

    ngAfterViewInit(): void {
        this.layoutRefService.addElement('header', this.ktHeader.nativeElement);
    }
}
